import * as __au2ViewDef from './signin-signup-window.html';
import {bindable, customElement, EventAggregator, inject} from "aurelia";
import {MdcSnackbarService} from "@aurelia-mdc-web/snackbar";
import {MdcDialog} from "@aurelia-mdc-web/dialog";
import {UserService} from "../../resources/services/user-service";

@inject(MdcSnackbarService)
@inject(MdcDialog)
@customElement({ ...__au2ViewDef, name: "signin-signup-window" })
export class SigninSignupWindow {
    mode: "Sign In" | "Sign Out" = "Sign In";
    username: string = "";
    password: string = "";

    constructor(
        private snackbar: MdcSnackbarService,
        private dialog: MdcDialog,
        //private backendService: BackendService,
        private userService: UserService,
        private eventAggregator: EventAggregator,
    ) {
    }

    attached() {
        localStorage.getItem("auth_token") ? (this.mode = "Sign Out") : null;
        if (this.mode === "Sign In") {
            this.dialog.open();
        }
    }

    async action() {
        if (this.mode === "Sign In") {
            if (!this.username || !this.password) {
                this.openToast("Please enter username and password");
            }
            const loginSuccess = await this.userService.login(
                this.username,
                this.password,
            );
            if (loginSuccess) {
                this.eventAggregator.publish("refresh", "Refresh button");
                this.mode = "Sign Out";
                this.dialog.close();
            } else {
                this.openToast("Wrong username or password");
            }
        } else {
            await this.userService.logout();
            this.eventAggregator.publish("refresh", "Refresh button");
            this.mode = "Sign In";
            this.dialog.close();
        }
    }

    async signUp() {
        const response = await this.userService.signup(
            this.username,
            this.password,
        );
        if (response) {
            this.mode = "Sign Out";
        }
    }

    openToast(message: string) {
        this.snackbar.open(message);
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = SigninSignupWindow;

    // @ts-ignore
    const proto = SigninSignupWindow.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }